// https://github.com/cartant/memoize-resolver/blob/master/source/resolver.ts

export function createResolver<Args extends any[]>(
  selector: (...args: Args) => unknown[] = (...args) => args
): (...args: Args) => string {
  let count = 0;
  const map = new WeakMap<object, string>();
  return (...args) =>
    selector(...args)
      .map((arg) => {
        if (arg && /^(function|object)$/.test(typeof arg)) {
          let key = map.get(arg as object);
          if (!key) {
            key = `@${++count}`;
            map.set(arg as object, key);
          }
          return key;
        }
        return JSON.stringify(arg);
      })
      .join(",");
}
